export default __webpack_public_path__ + "static/media/Pross-Phone.e9ce05da.webp";